<div role="radiogroup" [class]="computedGroupClasses()">
  @for (option of options; track option.value; let i = $index) { @if (cardMode) {
  <!-- Card Mode Radio Option -->
  <div class="relative">
    <!-- Hidden native radio for accessibility -->
    <input [id]="getOptionId(i)" type="radio" [name]="radioName" class="sr-only" [value]="option.value"
      [checked]="isSelected(option.value)" [disabled]="disabled || option.disabled"
      (change)="handleChange(option.value)" (focus)="onFocus()" (blur)="onBlur()" />

    <!-- Custom radio card -->
    <label [for]="getOptionId(i)" [class]="getCardClasses(option.value)" [attr.aria-checked]="isSelected(option.value)"
      [attr.aria-disabled]="disabled || option.disabled" role="radio" tabindex="0"
      (keydown)="handleKeyDown($event, option.value)">
      <div class="flex items-start space-x-3 relative z-10">
        <!-- Radio circle indicator -->
        <div [class]="getRadioClasses(option.value)">
          <!-- Selected dot -->
          @if (isSelected(option.value)) {
          <div class="absolute inset-0 flex items-center justify-center z-10">
            <div class="w-3 h-3 bg-primary-600 dark:bg-primary-400 rounded-full animate-glass-fade-in"></div>
          </div>
          }

          <!-- Glass shimmer effect -->
          <div
            class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none overflow-hidden rounded-full">
            <div class="absolute inset-0 bg-linear-to-r from-transparent via-primary-400/20 to-transparent
                                transform -skew-x-12 -translate-x-full group-hover:translate-x-full
                                transition-transform duration-1000 ease-out"></div>
          </div>
        </div>

        <!-- Content -->
        <div class="flex-1 min-w-0">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              @if (option.iconUrl) {
              <img [src]="option.iconUrl" alt="" class="w-8 h-6 object-contain mr-2" />
              } @else if (option.icon) {
              <ui-icon [name]="option.icon" [size]="iconSize()"
                customClass="mr-2 text-gray-600 dark:text-gray-300"></ui-icon>
              }
              <span [class]="getLabelClasses(option)">
                {{ option.label }}
                @if (required) {
                <span class="text-red-500 ml-1">*</span>
                }
              </span>
            </div>

            @if (customActionTemplate) {
            <div class="ml-auto" (click)="$event.stopPropagation()">
              <ng-container [ngTemplateOutlet]="customActionTemplate"
                [ngTemplateOutletContext]="{ $implicit: option, index: i }"></ng-container>
            </div>
            }
          </div>

          @if (option.description) {
          <p [class]="getDescriptionClasses()">
            {{ option.description }}
          </p>
          }

          <!-- Action buttons -->
          @if (option.actions && option.actions.length > 0) {
          <div class="flex items-center justify-end gap-3 mt-2" (click)="$event.stopPropagation()">
            @for (action of option.actions; track action.label) {
            @if (!action.hidden) {
            <button type="button" [disabled]="action.disabled" (click)="action.onClick(option, $event)"
              [class]="getActionButtonClasses(action.variant, action.disabled)">
              @if (action.icon) {
              <ui-icon [name]="action.icon" size="sm" customClass="inline-block mr-1"></ui-icon>
              }
              {{ action.label }}
            </button>
            }
            }
          </div>
          }
        </div>
      </div>

      <!-- Glass shimmer effect -->
      <div
        class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none overflow-hidden rounded-full">
        <div class="absolute inset-0 bg-linear-to-r from-transparent via-primary-400/20 to-transparent
                            transform -skew-x-12 -translate-x-full group-hover:translate-x-full
                            transition-transform duration-1000 ease-out"></div>
      </div>

      <!-- Premium floating particles -->
      @if (variant === 'premium') {
      <div
        class="absolute inset-0 overflow-hidden pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-700">
        <div class="absolute top-1/4 left-1/4 w-0.5 h-0.5 bg-primary-400/60 rounded-full animate-pulse"></div>
        <div class="absolute top-3/4 right-1/4 w-0.5 h-0.5 bg-white/40 rounded-full animate-pulse delay-500"></div>
        <div class="absolute bottom-1/3 right-1/3 w-0.5 h-0.5 bg-primary-300/50 rounded-full animate-pulse delay-1000">
        </div>
      </div>
      }

      <!-- Selected state glow -->
      @if (isSelected(option.value)) {
      <div class="absolute inset-0 rounded-full opacity-60 pointer-events-none">
        <div class="absolute inset-0 bg-primary-500/10 rounded-full animate-glass-pulse"></div>
      </div>
      }
    </label>
  </div>
  } @else {
  <!-- Standard Mode Radio Option -->
  <div class="flex items-start space-x-3 group">
    <!-- Radio Input -->
    <div class="relative flex items-center justify-center min-h-11 min-w-11">
      <!-- Hidden native radio for accessibility -->
      <input [id]="getOptionId(i)" type="radio" [name]="radioName" class="sr-only" [value]="option.value"
        [checked]="isSelected(option.value)" [disabled]="disabled || option.disabled"
        (change)="handleChange(option.value)" (focus)="onFocus()" (blur)="onBlur()" />

      <!-- Custom radio -->
      <label [for]="getOptionId(i)" [class]="getRadioClasses(option.value)"
        [attr.aria-checked]="isSelected(option.value)" [attr.aria-disabled]="disabled || option.disabled" role="radio"
        tabindex="0" (keydown)="handleKeyDown($event, option.value)">
        <!-- Selected dot -->
        @if (isSelected(option.value)) {
        <div class="absolute inset-0 flex items-center justify-center z-10">
          <div class="w-2 h-2 bg-primary-600 dark:bg-primary-400 rounded-full animate-glass-fade-in"></div>
        </div>
        }

        <!-- Glass shimmer effect -->
        <div
          class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none overflow-hidden rounded-full">
          <div class="absolute inset-0 bg-linear-to-r from-transparent via-primary-400/20 to-transparent
                              transform -skew-x-12 -translate-x-full group-hover:translate-x-full
                              transition-transform duration-1000 ease-out"></div>
        </div>

        <!-- Premium floating particles -->
        @if (variant === 'premium') {
        <div
          class="absolute inset-0 overflow-hidden pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-700">
          <div class="absolute top-1/4 left-1/4 w-0.5 h-0.5 bg-primary-400/60 rounded-full animate-pulse"></div>
          <div class="absolute top-3/4 right-1/4 w-0.5 h-0.5 bg-white/40 rounded-full animate-pulse delay-500"></div>
          <div
            class="absolute bottom-1/3 right-1/3 w-0.5 h-0.5 bg-primary-300/50 rounded-full animate-pulse delay-1000">
          </div>
        </div>
        }

        <!-- Selected state glow -->
        @if (isSelected(option.value)) {
        <div class="absolute inset-0 rounded-full opacity-60 pointer-events-none">
          <div class="absolute inset-0 bg-primary-500/10 rounded-full animate-glass-pulse"></div>
        </div>
        }
      </label>
    </div>

    <!-- Label and description -->
    <div class="flex-1 min-w-0">
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          @if (option.iconUrl) {
          <img [src]="option.iconUrl" alt="" class="w-8 h-6 object-contain mr-2" />
          } @else if (option.icon) {
          <ui-icon [name]="option.icon" [size]="iconSize()"
            customClass="mr-2 text-gray-600 dark:text-gray-300"></ui-icon>
          }
          <label [for]="getOptionId(i)" [class]="getLabelClasses(option)">
            {{ option.label }}
            @if (required) {
            <span class="text-red-500 ml-1">*</span>
            }
          </label>
        </div>

        @if (customActionTemplate) {
        <div class="ml-auto" (click)="$event.stopPropagation()">
          <ng-container [ngTemplateOutlet]="customActionTemplate"
            [ngTemplateOutletContext]="{ $implicit: option, index: i }"></ng-container>
        </div>
        }
      </div>

      @if (option.description) {
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
        {{ option.description }}
      </p>
      }

      <!-- Action buttons -->
      @if (option.actions && option.actions.length > 0) {
      <div class="flex items-center justify-end gap-3 mt-2" (click)="$event.stopPropagation()">
        @for (action of option.actions; track action.label) {
        @if (!action.hidden) {
        <button type="button" [disabled]="action.disabled" (click)="action.onClick(option, $event)"
          [class]="getActionButtonClasses(action.variant, action.disabled)">
          @if (action.icon) {
          <ui-icon [name]="action.icon" size="sm" customClass="inline-block mr-1"></ui-icon>
          }
          {{ action.label }}
        </button>
        }
        }
      </div>
      }
    </div>
  </div>
  } }
</div>

<!-- Error message -->
@if (errorMessage) {
<p class="text-sm text-red-600 dark:text-red-400 mt-2 flex items-center">
  <ui-icon name="alert-circle" size="sm" customClass="mr-1 shrink-0"></ui-icon>
  {{ errorMessage }}
</p>
}

<!-- Success message -->
@if (successMessage) {
<p class="text-sm text-cyan-600 dark:text-cyan-400 mt-2 flex items-center">
  <ui-icon name="check" size="sm" customClass="mr-1 shrink-0"></ui-icon>
  {{ successMessage }}
</p>
}